package org.braunequip.web.components.models

import kotlinx.serialization.Serializable

@Serializable
data class MaintSchedulesDTO(
    var id: Int? = null,
    var name: String = "",
    var intervalMiles: Int? = null,
    var intervalDays: Int? = null,
    var description: String = "",
    var appliedAssets: Int = 0,
    var createdAt: String? = null, // String for LocalDateTime
    var updatedAt: String? = null, // String for LocalDateTime
    var updatedBy: String? = null, // String for LocalDateTime
    var startDate: String? = null
)